<div class="offcanvas offcanvas-end" tabindex="-1" id="detail-lotto"
  aria-labelledby="offcanvasRightLabel">
  <ng-container *ngIf="DetailLotto">
    <div class="offcanvas-header">
      <h5 id="offcanvasRightLabel">[{{DetailLotto.gameProvider}}] Bill</h5>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body" [ngClass]="{'text-decoration-line-through': DetailLotto.gameResult == 'CANCEL'}">
      เลขตั๋ว : {{DetailLotto.betId}} <br>
      GAME ID : {{DetailLotto.gameBetId}}<br>
      Bet Date/Time : {{DetailLotto.timeBet | date:'dd/MM/yyyy HH:mm'}} <br>
      Settle Date/Time : {{DetailLotto.timeSettle | date:'dd/MM/yyyy HH:mm'}} <br>
      Type : {{DetailLotto.gameLottoType}}<br>
      <hr>
      <div class="table-responsive">
        <table class="table table-hover text-nowrap">
          <thead>
            <tr>
              <th>#</th>
              <th>ตัวเลข x แทง</th>
              <th>รายละเอียด</th>
              <th>ผลลัพธ์</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of DetailLotto.winlose_detail_lotto;let i = index">
              <td>
                {{i+1}}
              </td>
              <td>
                <u>{{data.betNumber}} x {{data.betAmount}}</u>
              </td>
              <td class="text-start">
                <div class="d-flex px-2">
                  <div class="w-50">
                    ประเภทการแทง
                  </div>
                  <div class="w-50 text-end">
                    {{data.lottoTypePlayName || 'no league'}}
                  </div>
                </div>
                <div class="d-flex px-2">
                  <div class="w-50">
                    อัตราการจ่า
                  </div>
                  <div class="w-50 text-end">
                    {{data.payout | number}} THB
                  </div>
                </div>
                <div class="d-flex px-2">
                  <div class="w-50">
                    ถูกรางวัลได้รับ
                  </div>
                  <div class="w-50 text-end">
                    <u>{{data.payoutAmount | number}} THB</u>
                  </div>
                </div>
              </td>
              <td>
                <span *ngIf="data.status == 'act' || data.status == 'pending'">
                  <i class="fas fa-spinner fa-spinner fa-spin text-info"></i>
                </span>
                <span *ngIf="data.status == 'win' || data.status == 'won' || data.status == 'true'">
                  <i class="bi bi-check-circle-fill text-success"></i>
                </span>
                <span *ngIf="data.status == 'los' || data.status == 'false'">
                  <i class="bi bi-x-circle-fill text-danger"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr>
      <div class="d-flex">
        <span class="w-50">Bet Amount</span>
        <span class="w-50 text-end">{{DetailLotto.betAmt | number : '.2-2'}} THB</span>
      </div>
      <div class="d-flex">
        <span class="w-50">Discount</span>
        <span class="w-50 text-end">0.00 THB</span>
      </div>
      <div class="d-flex">
        <span class="w-50">Status</span>
        <span class="w-50 text-end">
          <ng-container *ngIf="DetailLotto.gameStatus === 'done'">
            <span *ngIf="DetailLotto.gameResult === 'win' || DetailLotto.gameResult === 'won' || DetailLotto.gameResult === 'WIN'">
              WIN
            </span>
            <span
              *ngIf="DetailLotto.gameResult === 'los' || DetailLotto.gameResult === 'lose' || DetailLotto.gameResult === 'LOSE' || DetailLotto.gameResult === 'loss'">
              LOSE
            </span>
            <span class="text-uppercase" *ngIf="DetailLotto.gameResult === 'draw' || DetailLotto.gameResult === 'DRAW'">
              {{DetailLotto.gameResult}}
            </span>
          </ng-container>
          <ng-container *ngIf="DetailLotto.gameStatus !== 'done'">
            <span>RUNNING</span>
          </ng-container>
        </span>
      </div>
      <hr>
      <div class="d-flex">
        <span class="w-50">Total</span>
        <span class="w-50 text-end text-underline">{{DetailLotto.winLose}} THB</span>
      </div>
    </div>
  </ng-container>
</div>
